<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ $t('messageReplyModalTitle') }}</div>
    </template>
    <div class="p-pb-3">{{ header }}</div>
    <div id="iframe-container" class="iframe-container">
<!--      <iframe id="message-frame"-->
<!--              allow="fullscreen"-->
<!--              seamless-->
<!--              :srcdoc="srcdoc">-->
<!--      </iframe>-->
      <iframe id="message-frame"
              sandbox=""
              allow="fullscreen"
              seamless
              :srcdoc="srcdoc">
      </iframe>
    </div>
    <template #footer>
      <Button :label="$t('Close')" icon="pi pi-times" class="p-button-text" @click="close"/>
    </template>
  </Modal>
</template>
<script>
import formatMixins from "@/mixins/formatMixins";

export default {
  mixins: [ formatMixins ],
  components: { },
  emits: ['close'],
  name: 'EmailAnswerModal',
  props: {
    item: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      header: '',
      srcdoc: null
    }
  },
  watch: {
    item(value) {
      if (!value) {
        this.header = ''
        this.srcdoc = ''
        return
      }

      const textColorDiv = this.$store.getters.actualSchema === 'light' ? '<div style="color: #495057">' : '<div style="color: #FFFFFFDE">'

      let answer = `<base target="_blank">${textColorDiv}`
      let header = ''
      if (value.created_at) {
        // this.header += `<span><b>${this.formatDate(value.created_at)}</b></span>`
        header += `${this.formatDate(value.created_at)}`
      }

      // if (value.createdBy) {
      //   // this.header += `<span><b>, ${value.createdBy.first_name} ${value.createdBy.last_name}:</b></span>`
      //   header += `, ${value.createdBy.first_name} ${value.createdBy.last_name}:`
      // }

      if (value.createdBy) {
        const name = [value.createdBy.first_name, value.createdBy.last_name].filter(Boolean).join(' ')
        header += name ? `, ${name}:` : ':'
      }

      if (value.html_text) {
        answer += this.sanitizeEmailHtml(value.html_text) + '</div>'
      } else if (value.plain_text) {
        answer += `<div style="white-space: pre-wrap">${this.escapeHtml(value.plain_text)}</div></div>`
      }
      // else if (value.plain_text) {
      //   answer += `<div style="white-space: pre-wrap">${value.html_text}</div>`
      // }

      this.header = header
      this.srcdoc = answer
    },
  },
  methods: {
    escapeHtml(value) {
      return String(value || '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;')
    },
    sanitizeEmailHtml(html) {
      return String(html || '')
          .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
          .replace(/\son\w+="[^"]*"/gi, '')
          .replace(/\son\w+='[^']*'/gi, '')
          .replace(/<img[^>]+src=["']https?:\/\/[^"']+["'][^>]*>/gi, '')
    },
    close() {
      this.$emit('close')
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout) {
        return {position: 'absolute', top: 0, width: '95%', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '630px', marginTop: '15px'}
      } else {
        return {position: 'absolute', top: 0, width: '980px'}
      }
    },
  },

}
</script>

<style scoped lang="scss">
.iframe-container iframe {
  border: 0;
  padding: 0;
  width: 100%;
  height: 450px;
}
</style>